<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>

// A container for some global methods
window.configuratorapi = {}

export default {
  name: 'app',
  data: () => ({
  }),
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
